import { KnownQueryParamKey } from '../../constants/query-params';

const serializeQueryParams = (): Partial<Record<KnownQueryParamKey, string>> =>
    Object.fromEntries(new URLSearchParams(window.location.search)) as Partial<Record<KnownQueryParamKey, string>>;

export default serializeQueryParams;
